

export { default as ConfigProvider } from './config-provider';
export * from './table';